import { IoLogoTwitter } from "react-icons/io";
import { IoLogoInstagram } from "react-icons/io";
import { IoLogoYoutube } from "react-icons/io";
import { IoLogoTiktok } from "react-icons/io5";
import { TbBrandTelegram } from "react-icons/tb";
import { TbBrandSpotify } from "react-icons/tb";
import { ReactSVG } from "react-svg";

const navigation = {
  main: [
    { name: "Twitter", href: "https://twitter.com/cryptonikasDao" },
    {
      name: "Instagram",
      href: "https://www.instagram.com/cryptonikasdao/?igshid=YmMyMTA2M2Y=",
    },
    { name: "TikTok", href: "https://www.tiktok.com/@cryptonikasdao" },
    { name: "Telegram", href: "https://t.me/+TVTPRDty7pExNDI5" },
    {
      name: "YouTube",
      href: "https://www.youtube.com/channel/UCYsz3C6I6ilVhE0BmIVzDJA",
    },
    {
      name: "Spotify",
      href: "https://open.spotify.com/show/0I7mf8xUs9M2A6K8huiItV?si=4dd6dbcfe6804d6c",
    },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-neutral-900 pb-10">
      <div className="max-w-7xl mx-auto py-12 px-4 overflow-hidden sm:px-6 lg:px-8">
        <nav
          className="-mx-5 -my-2 flex flex-wrap justify-center"
          aria-label="Footer"
        >
          <div className="px-5 py-2">
            <a
              href="https://linktr.ee/cryptonikasdao"
              className="text-xl text-violet-600 font-semibold hover:text-violet-800"
              target="_blank"
            >
              ¡Síguenos!
            </a>
          </div>
        </nav>
        <div className="mt-8 flex justify-center space-x-6">
          <a
            href="https://opensea.io/CryptonikasDAO/created"
            className="text-gray-100 hover:text-gray-400"
            target="_blank"
          >
            <ReactSVG src="./opensea.svg" />
          </a>

          <div>
            <a
              href="https://twitter.com/cryptonikasDao"
              className="text-gray-100 hover:text-gray-400"
              target="_blank"
            >
              <span className="sr-only">Twitter</span>
              <IoLogoTwitter class="h-6 w-6" />
            </a>
          </div>

          <a
            href="https://www.instagram.com/cryptonikasdao/?igshid=YmMyMTA2M2Y="
            className="text-gray-100 hover:text-gray-400"
            target="_blank"
          >
            <span className="sr-only">Instagram</span>
            <IoLogoInstagram class="h-6 w-6" />
          </a>

          <a
            href="https://www.youtube.com/channel/UCYsz3C6I6ilVhE0BmIVzDJA"
            className="text-gray-100 hover:text-gray-400"
            target="_blank"
          >
            <span className="sr-only">Youtube</span>
            <IoLogoYoutube class="h-6 w-6" />
          </a>

          <a
            href="https://www.tiktok.com/@cryptonikasdao"
            className="text-gray-100 hover:text-gray-400"
            target="_blank"
          >
            <span className="sr-only">Tiktok</span>
            <IoLogoTiktok class="h-6 w-6" />
          </a>

          <a
            href="https://open.spotify.com/show/0I7mf8xUs9M2A6K8huiItV?si=4dd6dbcfe6804d6c"
            className="text-gray-100 hover:text-gray-400"
            target="_blank"
          >
            <span className="sr-only">Spotify</span>
            <TbBrandSpotify class="h-6 w-6" />
          </a>

          <a
            href="https://t.me/+TVTPRDty7pExNDI5"
            className="text-md text-gray-100 hover:text-gray-400"
            target="_blank"
          >
            <span className="sr-only">Telegram</span>
            <TbBrandTelegram class="h-6 w-6" />
          </a>
        </div>
        <p className="mt-8 text-center text-base text-gray-400">
          &copy; 2022 Cryptonikas DAO. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
